import { render, staticRenderFns } from "./HtmlBox.vue?vue&type=template&id=214252d6&scoped=true&"
import script from "./HtmlBox.vue?vue&type=script&lang=js&"
export * from "./HtmlBox.vue?vue&type=script&lang=js&"
import style0 from "./HtmlBox.vue?vue&type=style&index=0&id=214252d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214252d6",
  null
  
)

export default component.exports